angular.module('tgaAdmin').controller('RegisterController', [
  '$scope',
  '$state',
  '$window',
  '$cookies',
  '$sce',
  '$filter',
  '$location',
  'userService',
  'productService',
  'settingsService',
  'domainService',
  'stripe',
  'modalService',
  'supportService',
  'accountService',
  'orderService',
  'gameService',
  '$log',
  'constants',
  'Slug',
  '$translate',
  function (
    $scope,
    $state,
    $window,
    $cookies,
    $sce,
    $filter,
    $location,
    userService,
    productService,
    settingsService,
    domainService,
    stripe,
    modalService,
    supportService,
    accountService,
    orderService,
    gameService,
    $log,
    constants,
    Slug,
    $translate,
  ) {
    const redirectKey = 'tgaRedirect';

    userService.logout();

    $scope.data = {
      alerts: [],
      logo: 'https://static.thetrainingarcade.com/logos/logo-color.svg',
      referralOptions: [
        'Google Search',
        'LinkedIn Ad',
        'Trade Show/Virtual Conference',
        'Webinar',
        'Social Media post',
        'Blog Article',
        'Capterra',
        'Friend or Colleague',
        'Other',
      ],
      products: [],
      plans: [],
      addons: [],
      subTotal: 0,
      totalTotal: 0,
      agreementText: null,
      available_groups: [],
      taxRate: 0,
      salesTax: 0,
      adminPrice: 499,
      playerPrice: 500,
      svcPlanPrice: 2500,
      screens: ['plans', 'purchase', 'address', 'billing', 'success'],
      screen: 'plans',
      avataxLoading: false,
      avataxError: '',
      countries: constants.countries,
      states: constants.states,
      showArcadesDetails: false,
      uriPlanChosen: $location.search().plan,
    };

    $scope.viewmodel = {
      sso: null,
      token: null,
      first_name: null,
      last_name: null,
      email: null,
      confirm_email: null,
      password: null,
      confirm_password: null,
      domain: null,
      group_id: null,
      accepted_eula: null,
      agreement_id: null,
      admins: 0,
      players: 0,
      company: null,
      address: null,
      city: null,
      state: null,
      zip_code: null,
      country: 'US',
      phone: null,
      code: null,
      plan: null,
      games: [],
      products: [],
      addons: [], // selected addons
      service_plan: false,
      tax: 0,
      transaction: {
        code: null,
        customerCode: null,
      },
      withArcades: false,
    };

    $scope.card = {
      number: null,
      expiry: null,
      cvc: null,
    };

    $scope.promo = {
      code: null,
      description: null,
      discount: null,
      final_price: null,
      type: null,
    };

    $scope.user = null;

    $scope.$watch('viewmodel.phone', (phone) => {
      $scope.viewmodel.phone = $filter('telephone')(phone);
    });

    $scope.initialize = function (hideSpinner) {
      $scope.viewmodel.sso = $scope.getUrlParameter('sso') || 'elb'; // @TODO: ELB should add an sso parameter
      $scope.viewmodel.token = $scope.getUrlParameter('sessionToken');

      if ($scope.viewmodel.sso && $scope.viewmodel.token) {
        $scope.hideRegistration = true;

        if (!hideSpinner) {
          $scope.checkingSSO = true;
        }

        userService.ssoRegister($scope.viewmodel).then(
          (response) => {
            $scope.user = response;

            if (response.available_groups) {
              let disabledGroups = 0;

              for (let i = 0; i < response.available_groups.length; i++) {
                if (response.available_groups[i].domain) {
                  response.available_groups[i].optionGroupTitle = 'Log In';
                  // eslint-disable-next-line max-len
                  response.available_groups[
                    i
                  ].name = `${response.available_groups[i].name} (${response.available_groups[i].domain}.${domainService.base})`;
                } else if (
                  response.available_groups[i].role === 'master'
                  || response.available_groups[i].role === 'submaster'
                ) {
                  response.available_groups[i].optionGroupTitle = 'Create Subdomain';
                } else {
                  response.available_groups[i].optionGroupTitle = 'Log In';
                  response.available_groups[i].disabled = true;
                  disabledGroups++;
                }
              }

              // if all groups are disabled show error message under the dropdown
              if (disabledGroups === response.available_groups.length) {
                $scope.showAllDisabledMessage = true;
              }

              // if the user has only one group and it has a domain, we redirect them
              if (response.available_groups.length === 1 && response.available_groups[0].domain) {
                $scope.actions.redirect($scope.user, response.available_groups[0].domain);
                return;
              }

              $scope.data.available_groups = response.available_groups;
              $scope.showDomainForm = true;
            }

            // User needs to accept agreement
            if (response.agreement) {
              $scope.showDomainForm = false;
              $scope.showAgreementForm = true;
            }

            $scope.checkingSSO = false;
          },
          () => {
            $scope.hideRegistration = false;
            $scope.checkingSSO = false;
          },
        );
      }

      settingsService.getSettings().then((settings) => {
        $scope.data.adminPrice = settings.adminPrice ? settings.adminPrice : 499;
      });

      supportService.getAgreement().then((agreement) => {
        $scope.viewmodel.agreement_id = agreement.agreement_id;
        $scope.data.agreementText = agreement.text;
      });

      $scope.loading = true;
      $scope.loadingProducts = true;

      productService.getProducts().then((products) => {
        $scope.loading = false;
        $scope.loadingProducts = false;
        $scope.data.products = products.games;

        // TAGT-918 User can be routed to a chosen plan via uri.
        // Should be in the form of ?plan=3-game-pack
        // but we should also accept ?3-game-pack
        $scope.data.plans = products.bundles;
        $scope.data.addons = products.addons;

        $scope.data.plans.forEach((plan) => {
          plan.original_price = plan.price;
        });
        $scope.data.addons.forEach((addon) => {
          addon.original_price = addon.price;
        });

        let uriChosePlan = false;
        $scope.data.plans.forEach((plan) => {
          const slug = Slug.slugify(plan.name);
          if (
            ($scope.data.uriPlanChosen && $scope.data.uriPlanChosen === slug)
            || Object.keys($location.search()).indexOf(slug) > -1
          ) {
            uriChosePlan = true;
            // Set the uriPlanChosen just in case it was undefined.
            $scope.data.uriPlanChosen = slug;
            // Set the plan.
            $scope.actions.setPlan(plan);
            if (plan.name.indexOf('11 Game Pack') > -1) {
              // Advance to the second screen.
              $scope.actions.goToAddress();
            }
          }
        });
        if (!uriChosePlan) {
          $scope.data.uriPlanChosen = null;
        }

        const promo_code = $location.search().promo;
        if (promo_code) {
          $scope.loading = true;
          $scope.viewmodel.code = promo_code;

          // Promo code might now refer to Open Bundle instead of plans[2] by default
          accountService.getCoupon($scope.viewmodel.code).then((response) => {
            if (response && angular.isArray(response.game_types)) {
              // This is an open bundle, add to plans.
              const openPlan = {
                product_id: 24, // open bundle product_id
                product_type: 'pack',
                bundle_type: 'open',
                name: 'Open Bundle',
                max_games: response.game_types.length,
                game_types: response.game_types || [],
                num_admins: response.num_admins || 0,
                num_players: response.num_players || 0,
                price: response.bundle_price || 0, // 0 = use sum(game.price)
              };
              $scope.viewmodel.admins = openPlan.num_admins;
              $scope.viewmodel.players = openPlan.num_players;
              // $scope.data.plans.push(openPlan); // this would create another column
              $scope.actions.setPlan(openPlan);
              $scope.actions.goToAddress();
            } else {
              // default action
              $scope.actions.setPlan($scope.data.plans[2]);
              $scope.viewmodel.withArcades = true;
              $scope.actions.toggleArcades();
            }
            accountService
              .checkCoupon($scope.viewmodel.code, $scope.viewmodel.plan.product_id, $scope.viewmodel.admins)
              .then(
                (checkResponse) => {
                  $scope.loading = false;
                  $scope.promo = checkResponse;
                  $scope.actions.createAlert(
                    $translate.instant('common.activation_code_applied').toString(),
                    'success',
                  );
                  $scope.actions.subTotal();
                },
                (err) => {
                  $scope.loading = false;
                  $scope.showPrice = true;
                  $scope.actions.createAlert(err.message, 'danger');
                },
              );
          });
        } else {
          $scope.showPrice = true;
        }
      });

      // $log.log('DATADUMP at init', $scope.data, $scope.viewmodel);
    };

    $scope.actions = {
      toggleArcadesDetails() {
        const oldValue = $scope.data.showArcadesDetails;
        $scope.data.showArcadesDetails = !oldValue;
      },
      add1Admin() {
        $scope.viewmodel.admins += 1;
      },
      sub1Admin() {
        if ($scope.viewmodel.admins > 0) {
          $scope.viewmodel.admins -= 1;
        }
      },
      add500Players() {
        $scope.viewmodel.players += 1;
      },
      sub500Players() {
        if ($scope.viewmodel.players >= 1) {
          $scope.viewmodel.players -= 1;
        }
      },
      resetPromo() {
        $scope.data.alerts = [];

        $scope.promo = {
          code: null,
          description: null,
          discount: null,
          final_price: null,
          type: null, // 1 = percentage, 2 = fixed, 3 = trial, 4 = paid, 5 = partner
        };
      },
      checkCoupon() {
        $scope.loading = true;

        accountService
          .checkCoupon(
            $scope.viewmodel.code,
            $scope.viewmodel.plan.product_id,
            $scope.viewmodel.admins,
            $scope.viewmodel.players,
            $scope.viewmodel.service_plan,
          )
          .then(
            (response) => {
              $scope.loading = false;
              $scope.promo = response;

              if ($scope.promo.admins > 0) {
                $scope.viewmodel.admins = $scope.promo.admins;
              }

              if ($scope.promo.type === 3) {
                // trial
                $scope.showPrice = false;
              }

              $scope.actions.createAlert($translate.instant('common.activation_code_applied').toString(), 'success');
            },
            (err) => {
              $scope.loading = false;
              $scope.actions.createAlert(err.message, 'danger');
            },
          );
      },
      agreementForm() {
        if ($scope.agreementForm.$invalid) {
          return;
        }

        $scope.loading = true;

        userService.ssoRegister($scope.viewmodel).then(
          (response) => {
            $scope.user = response;

            if (response.available_groups) {
              for (let i = 0; i < response.available_groups.length; i++) {
                if (response.available_groups[i].domain) {
                  response.available_groups[i].optionGroupTitle = 'Login';
                  // eslint-disable-next-line max-len
                  response.available_groups[
                    i
                  ].name = `${response.available_groups[i].name} (${response.available_groups[i].domain}.${domainService.base})`;
                } else if (
                  response.available_groups[i].role === 'master'
                  || response.available_groups[i].role === 'submaster'
                ) {
                  response.available_groups[i].optionGroupTitle = 'Create Subdomain';
                }
              }

              $scope.data.available_groups = response.available_groups;
              $scope.showAgreementForm = false;
              $scope.showDomainForm = true;
              $scope.loading = false;
            }
          },
          (err) => {
            $scope.loading = false;
            $scope.actions.createAlert(err.message, 'danger');
          },
        );
      },
      domainForm() {
        if ($scope.domainForm.$invalid) {
          return;
        }

        if ($scope.viewmodel.selected_group.domain) {
          $scope.actions.redirect($scope.user, $scope.viewmodel.selected_group.domain);
          return;
        }

        $scope.viewmodel.group_id = $scope.viewmodel.selected_group.id;
        $scope.loading = true;

        userService.ssoRegister($scope.viewmodel).then(
          () => {
            $scope.loading = false;
            $scope.domainForm.submitted = false;
            $scope.viewmodel.domain = null;
            $scope.domain = null;
            $scope.initialize(true); // reinitialize to get all available groups
          },
          (err) => {
            $scope.loading = false;
            $scope.actions.createAlert(err.message, 'danger');
          },
        );
      },
      checkEmail() {
        if (!$scope.viewmodel.email) {
          $scope.invalidEmail = null;
          return;
        }

        userService.checkEmail($scope.viewmodel.email, true).then(
          () => {
            $scope.invalidEmail = null;
            $scope.addressForm.email.$setValidity('available', true);
          },
          () => {
            $scope.invalidEmail = true;
            $scope.addressForm.email.$setValidity('available', false);
          },
        );
      },
      checkDomain() {
        if (!$scope.viewmodel.domain) {
          $scope.domain = null;
          return;
        }

        $scope.checkingDomain = true;

        domainService.checkDomain($scope.viewmodel.domain).then(
          (domain) => {
            $scope.domain = domain;

            if (domain.available === false) {
              $scope.addressForm.domain.$setValidity('required', false);

              if ($scope.domainForm.domain) {
                $scope.domainForm.domain.$setValidity('required', false);
              }
            }

            $scope.checkingDomain = false;
          },
          (err) => {
            $scope.domain = {
              available: false,
            };

            if (err.message) {
              $scope.domain.message = err.message;
            }

            $scope.addressForm.domain.$setValidity('required', false);

            if ($scope.domainForm.domain) {
              $scope.domainForm.domain.$setValidity('required', false);
            }

            $scope.checkingDomain = false;
          },
        );
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      clearAlerts() {
        $scope.data.alerts = [];
      },
      redirect(user, domain) {
        const expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 1);

        // If available groups is too long it breaks the cookie
        delete user.available_groups;

        $cookies.putObject(redirectKey, user, {
          path: '/',
          domain: `.${domainService.base}`,
          expires: expireDate,
        });

        $window.location.href = `${$window.location.protocol}//${domain}.${domainService.base}/admin/v1/login`;
      },
      presentEula() {
        const message = $scope.data.agreementText
          ? `<div class="subs-agreement">${$scope.data.agreementText}</div>`
          : 'Error loading agreement';

        modalService.showModal(
          {
            title: 'Terms and Conditions',
            message,
            closeButton: false,
          },
          {
            backdrop: true,
            keyboard: true,
            animation: true,
            size: 'lg',
          },
        );
      },
      subTotal() {
        let total = 0;

        if ($scope.viewmodel.plan) {
          total = $scope.viewmodel.plan.price;
        }

        if ($scope.viewmodel.admins > 0) {
          total += $scope.viewmodel.admins * $scope.data.adminPrice;
        }

        if ($scope.viewmodel.addons.length) {
          for (let i = 0; i < $scope.viewmodel.addons.length; i++) {
            total += $scope.viewmodel.addons[i].price;
          }
        }

        if ($scope.viewmodel.service_plan > 0) {
          total += $scope.viewmodel.service_plan * $scope.data.svcPlanPrice;
        }

        if ($scope.viewmodel.players > 0) {
          total += $scope.viewmodel.players * $scope.data.playerPrice;
        }

        return total;
      },
      totalTotal() {
        let total = $scope.actions.subTotal();

        // trial, paid and partner promo types are free
        if ($scope.promo.type === 3 || $scope.promo.type === 4 || $scope.promo.type === 5) {
          $scope.promo.discount = total;
        }

        if ($scope.promo.discount > 0) {
          total -= $scope.promo.discount;
        }

        $scope.viewmodel.tax = total * $scope.data.taxRate;

        total += $scope.viewmodel.tax;

        return total > 0 ? Math.round(total) : 0;
      },
      goToAdmin() {
        $scope.actions.redirect($scope.user, $scope.viewmodel.domain);
      },
      setPlan(plan) {
        if (plan.bundle_type !== 'open' && $scope.data.plans.indexOf(plan) === -1) return;

        if ($scope.viewmodel.plan !== plan) {
          $scope.actions.resetPromo();
        }

        $scope.viewmodel.plan = plan;

        if ($scope.viewmodel.games.length > plan.max_games) {
          // more than max selected, reset to initial state
          $scope.viewmodel.games = [];
        }

        if (plan.bundle_type === 'open') {
          $scope.viewmodel.games = [];
          if (plan.game_types) {
            // Create a map of game_type -> data
            const mapGameTypes = [];
            let totalPrice = 0;
            gameService.getGameTypes().forEach((type) => {
              mapGameTypes[type.key] = type;
            });
            plan.game_types.forEach((game_type) => {
              if (mapGameTypes[game_type]) {
                const game = $scope.data.products.filter(
                  (g) => g.name === mapGameTypes[game_type].name || g.name.indexOf(mapGameTypes[game_type].name) > -1,
                );
                if (game[0]) {
                  $scope.viewmodel.games.push(game[0]);
                  totalPrice += game[0].price;
                }
              }
            });

            if (plan.price === 0) plan.price = totalPrice;
          }
        }

        if (plan.bundle_type === 'full') {
          $scope.viewmodel.games = [];

          // // turn on all games.
          for (let i = 0; i < $scope.data.products.length; i++) {
            const game = $scope.data.products[i];
            $scope.viewmodel.games.push(game);
          }
        }

        $scope.actions.goToAddress();

        // $log.log('AT END OF setPlan method:  ', $scope.data, $scope.viewmodel);
      },
      chooseAddon(addon) {
        const index = $scope.viewmodel.addons.indexOf(addon);

        if (index > -1) {
          $scope.viewmodel.addons.splice(index, 1);
        } else {
          $scope.viewmodel.addons.push(addon);
        }
      },
      toggleArcades() {
        if ($scope.viewmodel.withArcades) {
          $scope.data.addons.forEach((addon) => {
            if (addon.product_id === 22) {
              addon.price = 0;
              $scope.viewmodel.addons.push(addon);

              $scope.data.plans.forEach((plan) => {
                if (plan.num_players < 2500) {
                  plan.price += Math.floor(plan.price * 0.8);
                } else {
                  plan.price += addon.original_price;
                }
              });
            }
          });
        } else {
          $scope.viewmodel.addons = [];
          $scope.data.addons.forEach((addon) => {
            addon.price = addon.original_price;
          });
          $scope.data.plans.forEach((plan) => {
            plan.price = plan.original_price;
          });
        }
      },
      chooseGame(game) {
        const index = $scope.viewmodel.games.indexOf(game);

        if (index > -1) {
          $scope.viewmodel.games.splice(index, 1);
        } else {
          $scope.viewmodel.games.push(game);
        }

        // $log.log('game chosen: ', game, ' and viewmodel.chosenGames = ', $scope.viewmodel.games);
        // $log.log('AT END OF chooseGame method:  ', $scope.data, $scope.viewmodel);
      },
      goToPlans() {
        $window.scrollTo(0, 0);
        $scope.data.screen = 'plans';
      },
      goToPurchase() {
        $scope.addressForm.submitted = true;

        if ($scope.addressForm.$invalid) {
          return;
        }

        if ($scope.viewmodel.email !== $scope.viewmodel.confirm_email) {
          return;
        }

        if ($scope.viewmodel.password !== $scope.viewmodel.confirm_password) {
          return;
        }

        const changeToPurchasePage = () => {
          $window.scrollTo(0, 0);
          $scope.data.screen = 'purchase';
        };

        // Try to post the transaction then return the data we get back.
        $scope.data.avataxLoading = true;
        $scope.data.avataxError = '';
        $scope.addressForm.state.$invalid = false;
        const transactionData = {
          ...$scope.viewmodel,
          final_price: $scope.promo.final_price,
          discount: $scope.promo.discount,
        };
        orderService.postTransaction(transactionData).then(
          (transaction) => {
            $scope.data.avataxLoading = false;
            // Parse the transaction JSON.
            transaction = angular.fromJson(transaction.data);
            // $log.log('order service sent viewmodel', transactionData, 'and got back a transaction:',  transaction);

            // Update the tax rate.
            $scope.data.taxRate = transaction.summary[0].rate || 0;

            // Save a copy of the relevant transaction fields.
            $scope.viewmodel.transaction = {
              code: transaction.code, // adjust the transaction with this code
              customerCode: transaction.customerCode, // and this customer code
            };

            changeToPurchasePage();
          },
          (err) => {
            $scope.data.avataxLoading = false;
            if (err && err.message) {
              if (err.message.indexOf("'region'") > -1) {
                err.message = err.message.replace("'region'", "'state'");
                $scope.addressForm.state.$invalid = true;
              } else if (err.message.indexOf('state') > -1 && err.message.indexOf('postal code') > -1) {
                err.message = err.message.replace("'postal code'", "'zip code'");
                $scope.addressForm.state.$invalid = true;
                $scope.addressForm.zip_code.$invalid = true;
              } else if (err.message.indexOf('ForceTimeout') > -1) {
                err.message = $translate.instant('common.sales_tax_error').toString();
              }

              $scope.data.avataxError = err.message;
            }
          },
        );
      },
      goToAddress() {
        $window.scrollTo(0, 0);
        $scope.data.screen = 'address';
      },
      goToBilling() {
        const changeToBillingPage = () => {
          $window.scrollTo(0, 0);
          $scope.data.screen = 'billing';
        };

        // Try to post the transaction then return the data we get back.
        const transactionData = {
          ...$scope.viewmodel,
          final_price: $scope.promo.final_price,
          discount: $scope.promo.discount,
        };
        $scope.data.avataxLoading = true;
        orderService.postTransaction(transactionData).then(
          (transaction) => {
            $scope.data.avataxLoading = false;
            // Parse the transaction JSON.
            transaction = angular.fromJson(transaction.data);
            // $log.log('order service sent viewmodel', transactionData, 'and got back a transaction:',  transaction);

            // Update the tax rate.
            $scope.data.taxRate = transaction.summary[0].rate || 0;

            // Save a copy of the relevant transaction fields.
            $scope.viewmodel.transaction = {
              code: transaction.code, // adjust the transaction with this code
              customerCode: transaction.customerCode, // and this customer code
            };

            changeToBillingPage();
          },
          (err) => {
            $scope.data.avataxLoading = false;
            $log.error(err);
          },
        );
      },
      goToSuccess() {
        $scope.paymentForm.submitted = true;
        $scope.actions.clearAlerts();

        if ($scope.paymentForm.$invalid) {
          return;
        }

        $scope.loading = true;

        // bypass stripe token if free trial
        if ($scope.promo.type !== 3 && $scope.promo.type !== 4 && $scope.promo.type !== 5) {
          const card = {
            number: $scope.card.number,
            exp_month: $scope.card.expiry.month,
            exp_year: $scope.card.expiry.year,
            cvc: $scope.card.cvc,
          };
          stripe.card
            .createToken(card)
            .then((response) => {
              $scope.viewmodel.token = response.id;

              userService
                .registerUser($scope.viewmodel)
                .then((user) => {
                  const transactionData = {
                    ...$scope.viewmodel,
                    final_price: $scope.promo.final_price,
                    discount: $scope.promo.discount,
                  };

                  const afterCommit = () => {
                    $scope.user = user;
                    $scope.loading = false;
                    $window.scrollTo(0, 0);
                    $scope.data.screen = 'success';
                  };

                  orderService.postCommit(transactionData).then(
                    () => {
                      // Commit worked!
                      afterCommit();
                    },
                    () => {
                      $log.error('Unable to commit transaction data.');
                      // But the transaction on our end still processed, so advance them anyway.
                      afterCommit();
                    },
                  );
                })
                .catch((err) => {
                  $scope.loading = false;
                  $scope.actions.createAlert(err.message, 'danger');
                });
            })
            .catch((err) => {
              $scope.loading = false;
              $scope.actions.createAlert(err.message, 'danger');
            });
        } else {
          userService.registerUser($scope.viewmodel).then(
            (user) => {
              $scope.user = user;
              $scope.loading = false;
              $window.scrollTo(0, 0);
              $scope.data.screen = 'success';
            },
            (err) => {
              $scope.loading = false;
              $scope.actions.createAlert(err.message, 'danger');
            },
          );
        }
      },
    };

    $scope.getUrlParameter = function (name) {
      name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
      const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
      // eslint-disable-next-line no-restricted-globals
      const results = regex.exec(location.search);
      return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    $scope.countryFieldUpdated = function (country) {
      $scope.viewmodel.state = country !== 'US' ? '--' : null;
    };

    $scope.initialize();
  },
]);
